const p = (r, t, i, n) => r.filter(
  (o) => !(o.roomId === t && o.pricingTypeId === i && o.promotionId === n)
);
export {
  p as filterExistingCartItems
};
